import { Injectable, inject, signal } from '@angular/core';
import { EMPTY, catchError, finalize, tap } from 'rxjs';

import { BookingRequestRedirectDTO } from '@bookly/shared';

import { BookingApiService } from './booking-api.service';

@Injectable({
  providedIn: 'root',
})
export class BookingRedirectService {
  readonly #bookingApiService = inject(BookingApiService);

  readonly #bookingRequestRedirectSignal =
    signal<BookingRequestRedirectDTO | null>(null);
  readonly #isRedirectDataLoadingSignal = signal(false);
  readonly #errorSignal = signal(false);

  get bookingRequestRedirect() {
    return this.#bookingRequestRedirectSignal.asReadonly();
  }

  get isRedirectDataLoading() {
    return this.#isRedirectDataLoadingSignal.asReadonly();
  }

  get error() {
    return this.#errorSignal.asReadonly();
  }

  public determineBookingRequestRedirect(bookingId: string) {
    this.#isRedirectDataLoadingSignal.set(true);
    this.#errorSignal.set(false);
    return this.#bookingApiService
      .determineBookingRequestRedirect(bookingId)
      .pipe(
        tap(redirectData => {
          this.#bookingRequestRedirectSignal.set(redirectData);
        }),
        catchError(error => {
          console.log(error);
          this.#errorSignal.set(true);
          return EMPTY;
        }),
        finalize(() => this.#isRedirectDataLoadingSignal.set(false))
      );
  }
}
